





















// vendor
import { defineComponent, PropType, computed, ref } from "@vue/composition-api";
// local
import { FormItem, Answer, DataChannel } from "../../ts/types";
import ErrorOverlay from "./error-overlay.vue";
import ErrorBox from "./error-box.vue";

export default defineComponent({

	emits:[ "input" ],
	props:{
		value:{
			type:String
		},
		config:{
			type:Object as PropType<FormItem<Answer>>,
			required:true
		}
	},
	components:{
		ErrorOverlay,
		ErrorBox
	},
	setup(props, context){

		const pristine = ref(true);

		const val = computed({
			get:() => props.value,
			set:v => context.emit("input", v)
		});

		const state = computed(() => val.value !== undefined && val.value.length > 0);

		const isValid = () => {
			pristine.value = false;
			return Boolean(state.value);
		};

		const getChannels = (prefix:string):DataChannel<string>[] => {
			if(!val.value){ return []; }
			return [
				{
					key: prefix,
					data:val.value
				}
			];
		};

		const init = () => {
			if(val.value === undefined){ val.value = ""; }
		};

		init();

		return {
			pristine,
			state,
			val,
			isValid,
			getChannels
		};
		
	}
});
